import LeaveWorkspace from './LeaveWorkspace';
export default LeaveWorkspace;
